// extracted by mini-css-extract-plugin
export default {"CloseButton":"CloseButtonEditionArea_CloseButton__ZiDlt"};